import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const arjSettingsDependenciesLegacyRedirectRoute: InvariantJiraRoute = {
	name: 'arj-settings-dependencies-redirect',
	path: '/secure/PortfolioDependencySettings.jspa',
};
